import FormDetailPromotionSalePage from './FormDetailPromotionSalePage'
import { withFormDetailPromotionSalePage } from './withFormDetailPromotionSalePage'

const ConnectedFormDetailPromotionSalePage = withFormDetailPromotionSalePage(
  FormDetailPromotionSalePage
)

export { ConnectedFormDetailPromotionSalePage as FormDetailPromotionSalePage }
